import { getField, updateField } from 'vuex-map-fields';

import axios from 'axios';

const state = () => ({
    annualUsage: null,
    choseQuote: null,
    oneYearSaving: null,
    oneYearTotal: null,
    threeYearDiscount: null,
    threeYearTotal: null,
    threeYearSaving: null, 
    fiveYearDiscount: null,
    fiveYearTotal: null,
    fiveYearSaving: null,
    oneYearCalculation: null,
    threeYearCalculation: null,
    fiveYearCalculation: null,
    waterVolume: null,
    period: null,
    totalCharge: null,
})

const getters = {
    getField,
}

const actions = {
    submit({ commit, rootState }, period) {
        return new Promise((resolve, reject) => {
            const key = rootState.informationStep.key;
             
            const url = `/quotetoolapi/quote/setselectedquote`;

            const payload = { 
                period,
                key,
            };

            axios.put(url, payload).then(response => {
                commit('updatePeriod', period);
                commit('stepProgress/toggleStep', null, { root: true });
                resolve();
            }).catch(error => {
                reject(error);
            })
        })
    }
}

const mutations = {
    updateField,

    updateTotalCharge(state, period) {
        switch (period) {
            case 1:
                state.totalCharge = state.oneYearTotal;
                break;
            case 3:
                state.totalCharge = state.threeYearTotal;
                break;
            case 5:
                state.totalCharge = state.fiveYearTotal;
                break;
        }
    },

    updateQuoteData(state, data) { 

        state.oneYearSaving = data.oneYearSaving;
        state.oneYearTotal = data.oneYearTotal
        state.threeYearDiscount = data.threeYearDiscount;
        state.threeYearTotal = data.threeYearTotal;
        state.threeYearSaving = data.threeYearSaving;
        state.fiveYearDiscount = data.fiveYearDiscount;
        state.fiveYearTotal = data.fiveYearTotal;
        state.fiveYearSaving = data.fiveYearSaving;
        state.waterVolume = data.waterVolume;
        state.annualUsage = data.estimatedTotalAnnualConsumption;

        const baseLineItems = [
            {
                charges: 'Water fixed charge',
                wholesale: data.wholesaleWaterFixedCharge,
                retail: data.retailWaterFixedCharge,
                estimates: data.estimatedBillWaterFixedCharge,
                total: data.totalWaterFixedCharge
            },
            {
                charges: 'Water volumetric charge',
                wholesale: data.wholesaleWaterVolumetricCharge,
                retail: data.retailWaterVolumetricCharge,
                estimates: data.estimatedBillWaterVolumetricCharge,
                total: data.totalWaterVolumetricCharge
            },
            {
                charges: 'Sewerage fixed charge',
                wholesale: data.wholesaleSewerageFixedCharge,
                retail: data.retailSewerageFixedCharge,
                estimates: data.estimatedBillSewerageFixedCharge,
                total: data.totalSewerageFixedCharge
            },
            {
                charges: 'Sewerage volumetric charge',
                wholesale: data.wholesaleSewerageVolumetricCharge,
                retail: data.retailSewerageVolumetricCharge,
                estimates: data.estimatedBillSewerageVolumetricCharge,
                total: data.totalSewerageVolumetricCharge
            },
            {
                charges: 'Trade effluent fixed charge',
                wholesale: data.wholesaleTradeEffluentFixedCharge,
                retail: data.retailTradeEffluentFixedCharge,
                estimates: data.estimatedBillTradeEffluentFixedCharge,
                total: data.totalTradeEffluentFixedCharge
            },
            {
                charges: 'Trade effluent volumetric charge',
                wholesale: data.wholesaleTradeEffluentVolumetricCharge,
                retail: data.retailTradeEffluentVolumetricCharge,
                estimates: data.estimatedBillTradeEffluentVolumetricCharge,
                total: data.totalTradeEffluentVolumetricCharge
            },
        ];

        const calculationOneYear = {
            lineItems: baseLineItems.slice(),
            discount: 0,
            total: data.oneYearTotal
        }

        const calculationThreeYear = {
            lineItems: baseLineItems.slice(),
            discount: data.threeYearDiscount,
            total: data.threeYearTotal
        }

        const calculationFiveYear = {
            lineItems: baseLineItems.slice(),
            discount: data.fiveYearDiscount,
            total: data.fiveYearTotal
        }

        state.oneYearCalculation = calculationOneYear;
        state.threeYearCalculation = calculationThreeYear;
        state.fiveYearCalculation = calculationFiveYear;
    },

    updatePeriod(state, period) {
        state.period = period;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}